// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-tabs--border-card[data-v-a361ec26] {\n  border: none;\n}\n.div-dialog[data-v-a361ec26] {\n  width: 30%;\n  z-index: 10000;\n  position: absolute;\n  margin-left: 350px;\n  margin-top: 50px;\n  display: block;\n}\n", ""]);
// Exports
module.exports = exports;
